'use client';

import Script from 'next/script';
import { useConfiguration } from '~/context/common/StaticContext';
import { useDealershipConfiguration } from '~/context/dealership/StaticContext';

export default function DealerDotComScript() {
  const { enableWindowDealerCodeVar } = useConfiguration();
  const { dealerDotComCode } = useDealershipConfiguration();

  if (!dealerDotComCode) {
    return null;
  }

  if (enableWindowDealerCodeVar) {
    const serializedCode = JSON.stringify(dealerDotComCode).replace(
      /</g,
      '\\u003c'
    );

    return (
      <script
        dangerouslySetInnerHTML={{
          __html: `window.merchDealerDotComCode=${serializedCode};`
        }}
      />
    );
  }

  return (
    <Script
      strategy="afterInteractive"
      src={`https://assets.prod.analytics.dealer.com/pix-aop-auto.js?dealerCode=${dealerDotComCode}`}
    />
  );
}
